/**
 * @generated SignedSource<<e6175c071bffdb776fdfc8a8c65374bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReferralPartnerLogo_referralPartner$data = {
  readonly config: any | null;
  readonly name: string;
  readonly referralPartnerUploads: {
    readonly nodes: ReadonlyArray<{
      readonly upload: {
        readonly url: string;
      } | null;
    }>;
  };
  readonly " $fragmentType": "ReferralPartnerLogo_referralPartner";
};
export type ReferralPartnerLogo_referralPartner$key = {
  readonly " $data"?: ReferralPartnerLogo_referralPartner$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReferralPartnerLogo_referralPartner">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReferralPartnerLogo_referralPartner",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": {
              "equalTo": "logo"
            }
          }
        }
      ],
      "concreteType": "ReferralPartnerUploadsConnection",
      "kind": "LinkedField",
      "name": "referralPartnerUploads",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReferralPartnerUpload",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Upload",
              "kind": "LinkedField",
              "name": "upload",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "referralPartnerUploads(filter:{\"name\":{\"equalTo\":\"logo\"}})"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "config",
      "storageKey": null
    }
  ],
  "type": "ReferralPartner",
  "abstractKey": null
};

(node as any).hash = "5133f5366db1354fe7e3cff6ff9fd46e";

export default node;
